export const SOURCER = 'SOURCER';
export const SOURCER_MANAGER = 'SOURCER_MANAGER';
export const CREATOR_SOURCER = 'CREATOR_SOURCER';
export const CREATOR_SOURCER_MANAGER = 'CREATOR_SOURCER_MANAGER';

export const ROLES = [SOURCER, SOURCER_MANAGER, CREATOR_SOURCER, CREATOR_SOURCER_MANAGER];